<template>
  <div>
    <div class="row margin-b-s margin-t-m padding-h-m">
      <div class="small-6 columns">
        <div class="row">
          <div class="small-12 columns">
            <div class="service-info">
              <div class="title">{{ $t('rsvpDetails.serviceType') }}</div>
              <div class="value margin-b-s">{{ selectedService }}</div>

              <div class="title" v-if="showPickupType && !rsvp.isAsap">
                {{ $t('rsvpDetails.pickupType') }}
                <a class="editPickupType margin-l-s" href="javascript:;" @click="editPickupType" v-show="enablePickupTypeEdit">
                  {{ $t('rsvpDetails.edit') }}
                  <icon name="pencil" scale=".8"></icon>
                </a>
              </div>
              <div class="value margin-b-s" v-if="showPickupType && !rsvp.isAsap">
                <select class="field-select field-text pickupType" v-show="isEditingPickupType && enablePickupTypeEdit" @change="changePickupType($event)" v-model="selectedPickupType">
                  <option class="opt" v-for="(puType, key) in legInfo.pickupTypes" :name="puType.label" :data-pickuptype-fee="puType.fee" :value="key" :key="key">{{ puType.label + ' ' + pickupTypeFeeLabel(puType.fee, puType.label) }}</option>
                </select>
                <span v-show="!isEditingPickupType">{{ pickupTypeLabel(pickupType) }} {{ pickupTypeFeeLabel(pickupFee, pickupType) }}</span>
              </div>

              <div class="title" v-if="!rsvp.isAsap">
                <span v-if="charter.enabled">{{ $t('rsvpDetails.startDate') }}</span>
                <span v-else>{{ $t('rsvpDetails.pickupDate') }}</span>
              </div>
              <div class="value margin-b-s" v-if="!rsvp.isAsap">
                <span v-if="charter.enabled">{{ charter.startDate }}</span>
                <span v-else>{{ pickupDate }}</span>
              </div>
              
              <div class="title" v-if="charter.enabled">
                <span>{{ $t('rsvpDetails.endDate') }}</span>
              </div>
              <div class="value margin-b-s">
                <span>{{ charter.endDate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="!rsvp.isAsap">
          <div class="small-4 columns">
            <div class="service-info d-flex align-center">
              <span><icon name="users"></icon></span>
              <span class="value">{{ passenger }}</span>
            </div>
          </div>
          <div class="small-4 columns end">
            <div class="service-info d-flex align-center">
              <span><icon name="suitcase"></icon></span>
              <span class="value">{{ luggage }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="small-6 columns padding-l-s">
        <img :src="serviceImg" class="service-img" />
      </div>
    </div>

    <div class="row">
      <div class="medium-12 columns margin-b-m">
        <div v-if="showPaymentBreakdown" class="payment-breakdown">
          <payment-summary-form :flash="flash" :leg1="leg1" :leg2="leg2" :user="user" :currentLeg="currentLeg">
          </payment-summary-form>
        </div>
      </div>
    </div>

    <div class="row padding-h-m" v-if="charter.enabled">
      <div class="medium-12 columns margin-b-m">
        <panel-location-details :title="$t('rsvpDetails.pickup')" :details="charterDetails" :isDropoff="false" :currentLeg="currentLeg">
        </panel-location-details>
      </div>
    </div>

    <div class="row padding-h-m" v-else>
      <div class="medium-12 columns margin-b-m">
        <panel-location-details :title="$t('rsvpDetails.pickup')" :details="pickupDetails" :isDropoff="false" :currentLeg="currentLeg">
        </panel-location-details>
      </div>
    </div>

    <div class="row padding-h-m" v-if="extraStop.length && !charter.enabled">
      <div class="medium-12 columns margin-b-m">
        <panel-location-details :title="$t('rsvpDetails.extraStop')" :details="extraStopDetails" :isExtraStop="true" :currentLeg="currentLeg">
        </panel-location-details>
      </div>
    </div>

    <div class="row padding-h-m margin-b-m" v-if="!charter.enabled">
      <div class="medium-12 columns margin-b-m">
        <panel-location-details :title="$t('rsvpDetails.dropoff')" :details="dropoffDetails" :isDropoff="true" :currentLeg="currentLeg">
        </panel-location-details>
      </div>
    </div>

    <div class="row padding-h-m margin-b-m">
      <div class="medium-12 columns driver-notes">
        <label>{{ $t('rsvpDetails.driverNotes') }}</label>
        <textarea :placeholder="$t('rsvpDetails.inputNotes')"
          v-model="driverNote" @change="saveDriverNotes"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import PanelLocationDetails from '../Global/PanelLocationDetails.vue'
import PaymentSummaryForm from '../Payment/PaymentSummaryForm.vue'
import moment from 'moment'
import { isValidNumber } from 'libphonenumber-js'
import featureToggle from '@/modules/api/featureToggle'
import ApiPickupType from '@/modules/api/pickup-type'
import xcurrency from '@/modules/api/currency'

export default {
  name: 'reservation-details-header',
  props: ['leg', 'currentLeg', 'user', 'brand', 'flash', 'otherLeg'],
  data () {
    return {
      legInfo: {},
      isEditingPickupType: false,
      isUSMobile: true,
      driverNote: '',
      selectedPickupType: '',
      leg1: '',
      leg2: ''
    }
  },
  components: {
    'panel-location-details': PanelLocationDetails,
    'payment-summary-form': PaymentSummaryForm
  },
  computed: {
    rsvp () { return this.$store.state.reservation[this.currentLeg] },
    showPaymentBreakdown () { return this.$store.state.showPaymentBreakdown },
    selectedService () {
      let rsvp = this.$store.state.reservation[this.currentLeg]
      if (this.mtech.enabled) {
        return rsvp.selectedService ? this.mtech[this.currentLeg].services[rsvp.selectedService].desc : ''
      }
      let service = rsvp.services[rsvp.selectedService] ? rsvp.services[rsvp.selectedService].brandedName : ''
      if (service === 'Lyft') service = 'Prime Time Express'
      return service
    },
    passenger () { return this.$store.state.reservation[this.currentLeg].passenger },
    luggage () { return this.$store.state.reservation[this.currentLeg].luggage },
    pickupDetails () {
      let rsvp = this.$store.state.reservation[this.currentLeg]
      let result = { location: rsvp.pickup.title }

      if ((rsvp.isAsap || !rsvp.pickupDate) && !this.mtech.enabled) {
        result.date = 'ASAP'
      } else {
        result.date = moment(rsvp.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        if (this.mtech.enabled && this.mtech[this.currentLeg].pickupDate) {
          result.date = moment(this.mtech[this.currentLeg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        }
        result.date = result.date.format('MMM D, YYYY ' + featureToggle.timeFormat(this, false))
      }

      if (rsvp.apt && rsvp.apt.trim() !== '') { result.location += ` ${this.$t('rsvpDetails.aptGate')}:  ${rsvp.apt}` }
      result.upDownstairs = ''
      if (rsvp.isAirportPickup && rsvp.airline && rsvp.flightNo) {
        result.flight = `${rsvp.airline} ${this.$t('rsvpDetails.flight')} ${rsvp.flightNo}`
      }
      if (
        !this.mtech.enabled &&
        (rsvp.pickup.geofenceId === CONFIG.laxGeofenceId || CONFIG.showArrivalInstruction.indexOf(rsvp.pickup.geofenceId) > -1) &&
        rsvp.services[rsvp.selectedService]
      ) {
        let pickupLabel = this.$store.state.instructions
        result.upDownstairs = rsvp.services[rsvp.selectedService].licenseType === 'tcp' ? pickupLabel.tcp.pickupLabel : pickupLabel.tnc.pickupLabel
        // result.upDownstairs = ['black', 'suv', 'shuttle'].indexOf(rsvp.selectedService) > -1 ? 'Downstairs' : 'Upstairs'
      }

      return result
    },
    dropoffDetails () {
      let rsvp = this.$store.state.reservation[this.currentLeg]
      let threshold = 1.15
      let eta = Math.ceil(rsvp.eta / 60)
      let btt = parseInt(eta * threshold)
      if (rsvp.selectedService === 'shared') {
        btt = eta * (1 + (this.$settings.get('OfferLimitThreshold') / 100))
      }
      let dropoffTime = moment()
      if (rsvp.isAsap && rsvp.selectedService) {
        dropoffTime = dropoffTime.add(this.$store.state.reservation.serviceEta[rsvp.selectedService], 'minutes')
      } else if (rsvp.pickupDate) {
        dropoffTime = moment(rsvp.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
        // let services = this.mtech[this.currentLeg].services
        // if (rsvp.selectedService && services[rsvp.selectedService].pickupTimes && services[rsvp.selectedService].pickupTimes.length) {
        //   dropoffTime = moment(services[rsvp.selectedService].pickupTimes[0].unix, 'X')
        // }
      }
      if (this.mtech.enabled && this.mtech[this.currentLeg].pickupDate) {
        dropoffTime = moment(this.mtech[this.currentLeg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
      }
      dropoffTime = dropoffTime.add(btt, 'minutes')
      let result = { location: rsvp.dropoff.title }
      // if (this.mtech.enabled) {
      //   dropoffTime = dropoffTime.tz(this.rsvp.timezone)
      // }

      if (rsvp.isAsap || !rsvp.pickupDate) {
        let dateFormat = 'lll'
        if (this.$settings.get('MilitaryTimeWidget')) {
          dateFormat = this.$settings.get('MilitaryTimeWidget') === '1' ? 'MMM D, YYYY HH:mm' : 'lll'
        }
        result.date = moment().tz(rsvp.timezone)
          .add(this.$store.state.reservation.webTimeBuffer, 'minutes')
          .add(parseInt(rsvp.eta * threshold), 'seconds')
          .format(dateFormat)
      } else {
        result.date = dropoffTime.format('MMM D, YYYY ' + featureToggle.timeFormat(this, false))
      }

      result.upDownstairs = ''
      if (!rsvp.isAirportPickup && rsvp.isAirportDropoff && rsvp.airline) {
        result.flight = rsvp.airline
        if (rsvp.flightNo) {
          result.flight += ` ${this.$t('rsvpDetails.flight')} ${rsvp.flightNo}`
        }
      }

      return result
    },
    pickupType () {
      let leg = this.$store.state.reservation[this.currentLeg]
      if (leg.isAsap) {
        this.selectedPickupType = 'Curbside'
        return 'Curbside'
      }
      this.selectedPickupType = leg.pickupType
      return leg.pickupType
    },
    pickupFee () {
      let leg = this.$store.state.reservation[this.currentLeg]
      if (leg.isAsap) {
        return 0
      }
      return leg.pickupFee
    },
    _pickupType () {
      let rsvp = this.$store.state.reservation[this.currentLeg]
      if (!rsvp.isAirportPickup) { return '' }

      if (!this.$store.state.user.token) {
        if (rsvp.isAirportPickup) {
          let type = 'Curbside'
          let fee = 0
          if (!this.mtech.enabled) {
            if (rsvp.services[rsvp.selectedService].meetAndGreet) {
              type = 'MeetAndGreet'
              fee = rsvp.services[rsvp.selectedService].pickupFee
            }
            if (rsvp.services[rsvp.selectedService].curbside) {
              type = 'Curbside'
              fee = 0
            }
          }
          return this.legInfo.pickupTypes[type].label + '  ' + this.pickupTypeFeeLabel(fee, type)
        }
        return ''
      }

      if (this.isUSMobile) {
        if (rsvp.pickupType) {
          return this.legInfo.pickupTypes[rsvp.pickupType].label + '  ' + this.pickupTypeFeeLabel(rsvp.pickupFee, rsvp.pickupType)
        }
        if (!this.mtech.enabled && !rsvp.services[rsvp.selectedService].curbside && rsvp.services[rsvp.selectedService].meetAndGreet) {
          return this.legInfo.pickupTypes['MeetAndGreet'].label + '  ' + this.pickupTypeFeeLabel(rsvp.pickupFee, 'MeetAndGreet')
        }
        return this.legInfo.pickupTypes['Curbside'].label + '  ' + this.pickupTypeFeeLabel(0, 'Curbside')
      } else {
        if (rsvp.selectedService === 'shared') {
          return 'Curbside'
        }

        if (!this.legInfo.pickupTypes.MeetAndGreet) {
          return 'Meet & Greet ' + this.pickupTypeFeeLabel(0, 'MeetAndGreet')
        }

        return this.legInfo.pickupTypes.MeetAndGreet.label + ' ' + this.pickupTypeFeeLabel(this.legInfo.pickupTypes.MeetAndGreet.fee, 'MeetAndGreet')
      }
    },
    enablePickupTypeEdit () {
      let user = this.$store.state.user
      if (this.$store.state.reservation.leg1.isAsap) { return false }
      if (this.mtech.enabled) { return false }

      if (user.phone.number) {
        let userPhone = '+' + user.phone.code + user.phone.number
        let isUs = isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
        if (!isUs) { return false }
      }

      if (!this.isUSMobile && !!user.phone.number) { return false }
      if (this.legInfo.pickupTypes) {
        return Object.keys(this.legInfo.pickupTypes).length > 1
      }
      return false
    },
    showPickupType () { return this.$store.state.reservation[this.currentLeg].isAirportPickup },
    serviceImg () {
      let rsvp = this.$store.state.reservation[this.currentLeg]
      let selectedRsvp = rsvp.selectedService

      if (this.mtech.enabled) {
        return selectedRsvp ? this.mtech[this.currentLeg].services[selectedRsvp].img : ''
      }

      return selectedRsvp && rsvp.services[selectedRsvp] ? rsvp.services[selectedRsvp].img : ''
    },
    pickupDate () {
      let rsvp = this.$store.state.reservation[this.currentLeg]
      if (rsvp.isAsap || !rsvp.pickupDate) { return '' }
      if (this.mtech.enabled) {
        return this.mtech[this.currentLeg].pickupDate ? moment(this.mtech[this.currentLeg].pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false)).format('MMM D, YYYY ' + featureToggle.timeFormat(this, false)) : ''
      }
      return rsvp.pickupDate ? moment(rsvp.pickupDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false)).format('MMM D, YYYY ' + featureToggle.timeFormat(this, false)) : ''
    },
    extraStop () { return this.$store.state.reservation.extraStop[this.currentLeg] },
    extraStopDetails () {
      let stops = []
      this.extraStop.forEach(stop => {
        stops.push({location: stop.text})
      })
      return stops
    },
    charter () { return this.$store.state.reservation.charter },
    charterDetails () {
      let rsvp = this.$store.state.reservation.leg1
      let result = {
        location: this.charter.pickup.title,
        date: moment(this.charter.startDate, 'MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
          .format('MMM D, YYYY ' + featureToggle.timeFormat(this, false))
      }

      if (rsvp.apt && rsvp.apt.trim() !== '') { result.location += ' Apt/Gate: ' + rsvp.apt }
      result.upDownstairs = ''
      if (rsvp.isAirportPickup && rsvp.airline && rsvp.flightNo) {
        result.flight = `${rsvp.airline} ${this.$t('rsvpDetails.flight')} ${rsvp.flightNo}`
      }
      if (
        !this.mtech.enabled &&
        (rsvp.pickup.geofenceId === CONFIG.laxGeofenceId || CONFIG.showArrivalInstruction.indexOf(rsvp.pickup.geofenceId) > -1) &&
        rsvp.services[rsvp.selectedService]
      ) {
        let pickupLabel = this.$store.state.instructions
        result.upDownstairs = rsvp.services[rsvp.selectedService].licenseType === 'tcp' ? pickupLabel.tcp.pickupLabel : pickupLabel.tnc.pickupLabel
      }

      return result
    },
    _route () { return this.$route.name },
    mtech () { return this.$store.state.reservation.mtech },
    _pickupDate () { return this.$store.state.reservation[this.currentLeg].pickupDate },
    _flightDate () { return this.$store.state.reservation[this.currentLeg].flightDate },
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    getServiceNameByID: function (id) {
      let brand = this.brand + '-'
      if (this.brand === 'gs') { brand = '' }
      switch (id) {
        case 1: return brand + 'shared'
        case 2: return brand + 'opoli'
        case 3: return brand + 'black'
        case 4: return brand + 'suv'
        case 5: return brand + 'privateshuttle'
        default: return brand + 'opoli'
      }
    },
    editPickupType: function () {
      this.isEditingPickupType = !this.isEditingPickupType
    },
    // changePickupType: function (event) {
    changePickupType (event) {
      if (
        ((this.isUSMobile || !this.$store.state.user.token) && event.target.value) ||
        (this.mtech.enabled && event.target.value)
      ) {
        this.$store.commit('reservation/setPickupType', {
          leg: this.currentLeg,
          type: event.target.value,
          fee: this.legInfo.pickupTypes[event.target.value].fee
        })
        this.legInfo.pickupType = event.target.value
      }
      this.isEditingPickupType = false
    },
    // selectedPickupType (selected) { return selected === this.pickupType },
    pickupTypeLabel (type) {
      let rsvp = this.$store.state.reservation[this.currentLeg]
      if (
        !this.mtech.enabled &&
        (rsvp.pickup.geofenceId === CONFIG.laxGeofenceId || CONFIG.showArrivalInstruction.indexOf(rsvp.pickup.geofenceId) > -1) &&
        rsvp.services[rsvp.selectedService]
      ) {
        let pickupLabel = this.$store.state.instructions
        return rsvp.services[rsvp.selectedService].licenseType === 'tcp' ? pickupLabel.tcp.pickupLabel : pickupLabel.tnc.pickupLabel
      }

      switch (type) {
        case 'Curbside': return this.$t('rsvpDetails.curbside')
        case 'MeetAndGreet': return this.$t('rsvpDetails.mng')
        default: return ''
      }
    },
    pickupTypeFeeLabel (fee, type) {
      if (Number(fee) > 0) {
        return `(${this.applyCurrency(fee.toFixed(2))})`
        // return '($' + Number(fee).toFixed(2) + ')'
      }
      return (type !== 'Curbside') ? `(${this.$t('rsvpDetails.complimentary')})` : ''
    },
    saveDriverNotes: function () {
      let self = this
      this.$store.commit('setDriverNotes', {
        leg: self.currentLeg,
        notes: self.driverNote
      })
    },
    applyCurrency (x, useSymbol = true) {
      x = parseFloat(x)
      x = x * this.currency.value

      if (!useSymbol) return parseFloat(x.toFixed(2))
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol)
      // return x >= 0 ? `${this.currency.symbol}${x.toFixed(2)}` : `-${this.currency.symbol}${Math.abs(x).toFixed(2)}`
    }
  },
  watch: {
    leg (val) {
      this.$forceUpdate()
      if (this.currentLeg === 'leg1') {
        this.leg1 = val
        this.leg2 = this.otherLeg
      } else {
        this.leg1 = this.otherLeg
        this.leg2 = val
      }
      if (val && val.pickupText) {
        this.legInfo = Object.assign({}, this.legInfo, val)
      }
    },
    selectedService (val) {
      this.$forceUpdate()
    },
    _route (val) {
      this.$forceUpdate()
      if (val && this.rsvp.pickupType) {
        this.selectedPickupType = this.rsvp.pickupType
      }
    },
    _pickupDate (val) {
      this.$forceUpdate()
    },
    _flightDate (val) {
      this.$forceUpdate()
    }
  },
  mounted: function () {
    if (this.leg) {
      this.legInfo = Object.assign({}, this.legInfo, this.leg)
    }

    this.driverNote = this.$store.state.driverNotes[this.currentLeg]

    let user = this.$store.state.user
    if (user.phone.number) {
      let self = this
      let userPhone = '+' + user.phone.code + user.phone.number
      let notInternational = isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
      ApiPickupType.update(self, {isUS: notInternational}, function (data) {
        if (data.action === 'mobileCCUpdate') {
          let rsvp = self.$store.state.reservation
          if (rsvp.leg1.isAirportPickup) {
            self.$root.$emit('mobileCCUpdate', {
              isUS: data.isUS,
              pickupType: rsvp.leg1.pickupType,
              fee: rsvp.leg1.pickupFee
            })
          }
          if (rsvp.isRoundtrip && rsvp.leg2.pickupHasAirline) {
            self.$root.$emit('mobileCCUpdate', {
              isUS: data.isUS,
              pickupType: rsvp.leg2.pickupType,
              fee: rsvp.leg2.pickupFee
            })
          }
        }
      })
    }

    this.$forceUpdate()
    let self = this
    this.$root.$on('mobileCCUpdate', val => {
      // self.isUSMobile = 2
      // this.legInfo.pickupType = ''
      // this.legInfo.pickupFee = 0

      self.$nextTick(function () {
        self.isUSMobile = val.isUS
        if (val.pickupType) { self.legInfo.pickupType = val.pickupType }
        if (val.fee) { self.legInfo.pickupFee = val.fee }
      })
    })

    self.$root.$on('logoutSuccess', function () {
      // console.log('on logout')
      self.$forceUpdate()
    })
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/Reservation/ReservationDetailsHeader.scss";
textarea{ outline: none; }
.service-img{
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  max-width: 80%!important;
}
.payment-breakdown{
  background: #f3f3f3;
  border-bottom: 1px solid #ccc;
  padding-bottom: 15px;
}
.service-info.d-flex{
  gap: 8px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// ReservationDetailsHeader.vue?84e67842